<template>
    <div class="toggle" :class="[{ checked: localValue, locked }, sizeClass]" @click="onToggle">
        <div class="toggle-circle"></div>
        <div v-if="locked" class="lock-icon">
            <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.30002 4.39995V3.94281C2.30002 2.42335 3.50431 1.19995 5.00002 1.19995C6.49574 1.19995 7.70003 2.42335 7.70003 3.94281V4.39995M2.30002 4.39995C1.80502 4.39995 1.40002 4.81138 1.40002 5.31424V9.88566C1.40002 10.3885 1.80502 10.7999 2.30002 10.7999H7.70003C8.19503 10.7999 8.60003 10.3885 8.60003 9.88566V5.31424C8.60003 4.81138 8.19503 4.39995 7.70003 4.39995M2.30002 4.39995H7.70003"
                    stroke="white" stroke-opacity="0.4" stroke-linecap="round" />
            </svg>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue"

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    locked: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: "default"
    }
})

const emit = defineEmits(["update:modelValue"])

const localValue = ref(props.modelValue)
const sizeClass = `toggle-${props.size}`

watch(
    () => props.modelValue,
    newVal => {
        localValue.value = newVal
    }
)

function onToggle() {
    if (props.locked) return
    localValue.value = !localValue.value
    emit("update:modelValue", localValue.value)
}
</script>

<style scoped>
.toggle {
    width: var(--toggle-width);
    height: var(--toggle-height);
    background-color: var(--color-disabled);
    border-radius: var(--border-radius-toggle);
    position: relative;
    cursor: pointer;
    transition: var(--transition-bg);
    display: inline-block;
}

.toggle.checked {
    background-color: var(--color-success);
}

.toggle.locked {
    background-color: var(--color-disabled-dark) !important;
    cursor: not-allowed;
}

.toggle-circle {
    width: var(--toggle-circle-size);
    height: var(--toggle-circle-size);
    background-color: var(--color-white);
    border-radius: var(--border-radius-circle);
    position: absolute;
    top: var(--toggle-circle-offset);
    left: var(--toggle-circle-offset);
    transition: var(--transition-transform);
}

.toggle.checked .toggle-circle {
    transform: translateX(var(--toggle-circle-translate));
}

.lock-icon {
    position: absolute;
    right: var(--spacing-md);
    top: var(--toggle-circle-offset);
    pointer-events: none;
}

.toggle-compact {
    width: 2.4rem;
    height: 1.25rem;
}

.toggle-compact .toggle-circle {
    width: 0.95rem;
    height: 0.95rem;
    top: 0.15rem;
    left: 0.15rem;
}

.toggle-compact.checked .toggle-circle {
    transform: translateX(1.15rem);
}

.toggle-compact .lock-icon {
    right: 0.4rem;
    top: 0.1rem;
    transform: scale(0.8);
    transform-origin: center;
}
</style>
